"use strict";
var SignCore = (() => {
  var __defProp = Object.defineProperty;
  var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
  var __getOwnPropNames = Object.getOwnPropertyNames;
  var __hasOwnProp = Object.prototype.hasOwnProperty;
  var __export = (target, all) => {
    for (var name in all)
      __defProp(target, name, { get: all[name], enumerable: true });
  };
  var __copyProps = (to, from, except, desc) => {
    if (from && typeof from === "object" || typeof from === "function") {
      for (let key of __getOwnPropNames(from))
        if (!__hasOwnProp.call(to, key) && key !== except)
          __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
    }
    return to;
  };
  var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);

  // core/sign-core/browser.ts
  var browser_exports = {};
  __export(browser_exports, {
    CORO_CNC_ZONES: () => CORO_CNC_ZONES,
    HEADER_PROBE_BYTES: () => HEADER_PROBE_BYTES,
    PRODUCTION_LEAD_BUSINESS_DAYS: () => PRODUCTION_LEAD_BUSINESS_DAYS,
    PRODUCTION_TIERS: () => PRODUCTION_TIERS,
    RUSH_LADDER: () => RUSH_LADDER,
    SHOP_CALENDAR: () => SHOP_CALENDAR,
    SIGN_CORE_VERSION: () => SIGN_CORE_VERSION,
    SIGN_MIN_DPI: () => SIGN_MIN_DPI,
    SIGN_OUTLINES: () => SIGN_OUTLINES,
    SIGN_QUANTITIES: () => SIGN_QUANTITIES,
    SIGN_SPECS: () => SIGN_SPECS,
    SIGN_SPEC_IDS: () => SIGN_SPEC_IDS,
    SIGN_STAKES_OPTIONS: () => SIGN_STAKES_OPTIONS,
    SIGN_WARN_DPI: () => SIGN_WARN_DPI,
    addBusinessDays: () => addBusinessDays,
    availableOrientations: () => availableOrientations,
    bandFor: () => bandFor,
    buildPriceTable: () => buildPriceTable,
    calendarDate: () => calendarDate,
    dpiTier: () => dpiTier,
    effectiveDpi: () => effectiveDpi,
    expectedVariantKeys: () => expectedVariantKeys,
    formatFee: () => formatFee,
    formatShipDate: () => formatShipDate,
    isOpenDay: () => isOpenDay,
    isOrientationAvailable: () => isOrientationAvailable,
    isSidesAvailable: () => isSidesAvailable,
    megapixels: () => megapixels,
    pointsSiblings: () => pointsSiblings,
    productionStartDate: () => productionStartDate,
    readImageDimensions: () => readImageDimensions,
    resolveSelection: () => resolveSelection,
    resolveSign: () => resolveSign,
    shipDate: () => shipDate,
    shipDates: () => shipDates,
    sidesFor: () => sidesFor,
    signVariantCount: () => signVariantCount,
    tierFee: () => tierFee,
    toISODate: () => toISODate,
    variantKey: () => variantKey
  });

  // core/sign-core/spec.ts
  var CORO_CNC_ZONES = {
    bleedIn: 0.125,
    trimToleranceIn: 0.125,
    safeMarginIn: 0.125
  };

  // core/image-header.ts
  var HEADER_PROBE_BYTES = 65536;
  function be16(b, i) {
    return b[i] << 8 | b[i + 1];
  }
  function be32(b, i) {
    return (b[i] << 24 | b[i + 1] << 16 | b[i + 2] << 8 | b[i + 3]) >>> 0;
  }
  function le24(b, i) {
    return b[i] | b[i + 1] << 8 | b[i + 2] << 16;
  }
  function ascii(b, i, s) {
    for (let k = 0; k < s.length; k++) if (b[i + k] !== s.charCodeAt(k)) return false;
    return true;
  }
  function pngDimensions(b) {
    if (b.length < 24) return null;
    const sig = [137, 80, 78, 71, 13, 10, 26, 10];
    for (let i = 0; i < 8; i++) if (b[i] !== sig[i]) return null;
    if (!ascii(b, 12, "IHDR")) return null;
    return { w: be32(b, 16), h: be32(b, 20) };
  }
  function exifOrientation(b, t, end) {
    if (t + 8 > end || t + 8 > b.length) return null;
    let le;
    if (ascii(b, t, "II")) le = true;
    else if (ascii(b, t, "MM")) le = false;
    else return null;
    const u16 = (i) => le ? b[i] | b[i + 1] << 8 : be16(b, i);
    const u32 = (i) => le ? (b[i] | b[i + 1] << 8 | b[i + 2] << 16 | b[i + 3] << 24) >>> 0 : be32(b, i);
    if (u16(t + 2) !== 42) return null;
    const ifd = t + u32(t + 4);
    if (ifd < t || ifd + 2 > end) return null;
    const count = u16(ifd);
    for (let k = 0; k < count; k++) {
      const e = ifd + 2 + k * 12;
      if (e + 12 > end) return null;
      if (u16(e) !== 274) continue;
      const type = u16(e + 2);
      if (type !== 3 && type !== 4) return null;
      const v = type === 3 ? u16(e + 8) : u32(e + 8);
      return v >= 1 && v <= 8 ? v : null;
    }
    return null;
  }
  function transposes(orientation) {
    return orientation >= 5 && orientation <= 8;
  }
  function jpegDimensions(b) {
    if (b.length < 4 || b[0] !== 255 || b[1] !== 216) return null;
    let i = 2;
    let orientation = null;
    while (i + 3 < b.length) {
      if (b[i] !== 255) {
        i++;
        continue;
      }
      const marker = b[i + 1];
      if (marker === 255 || marker === 1 || marker >= 208 && marker <= 217) {
        i += 2;
        continue;
      }
      const len = be16(b, i + 2);
      if (len < 2) return null;
      const isSof = marker >= 192 && marker <= 207 && marker !== 196 && marker !== 200 && marker !== 204;
      if (marker === 225 && orientation === null && i + 10 <= b.length && ascii(b, i + 4, "Exif") && b[i + 8] === 0 && b[i + 9] === 0) {
        orientation = exifOrientation(b, i + 10, Math.min(i + 2 + len, b.length));
      }
      if (isSof) {
        if (i + 9 >= b.length) return null;
        const h = be16(b, i + 5);
        const w = be16(b, i + 7);
        return orientation !== null && transposes(orientation) ? { w: h, h: w } : { w, h };
      }
      if (marker === 218) return null;
      i += 2 + len;
    }
    return null;
  }
  function webpDimensions(b) {
    if (b.length < 30 || !ascii(b, 0, "RIFF") || !ascii(b, 8, "WEBP")) return null;
    if (ascii(b, 12, "VP8X")) {
      return { w: le24(b, 24) + 1, h: le24(b, 27) + 1 };
    }
    if (ascii(b, 12, "VP8L")) {
      if (b[20] !== 47) return null;
      const bits = b[21] | b[22] << 8 | b[23] << 16 | b[24] << 24;
      return { w: (bits & 16383) + 1, h: (bits >> 14 & 16383) + 1 };
    }
    if (ascii(b, 12, "VP8 ")) {
      if (b[23] !== 157 || b[24] !== 1 || b[25] !== 42) return null;
      return {
        w: (b[26] | b[27] << 8) & 16383,
        h: (b[28] | b[29] << 8) & 16383
      };
    }
    return null;
  }
  function readImageDimensions(bytes) {
    var _a, _b;
    const d = (_b = (_a = pngDimensions(bytes)) != null ? _a : jpegDimensions(bytes)) != null ? _b : webpDimensions(bytes);
    if (!d) return null;
    if (!Number.isFinite(d.w) || !Number.isFinite(d.h) || d.w <= 0 || d.h <= 0) return null;
    return d;
  }
  function megapixels(d) {
    return d.w * d.h / 1e6;
  }

  // core/sign-core/registry.ts
  var ARROW_CNC_ZONES = {
    ...CORO_CNC_ZONES,
    bleedIn: 0.25
  };
  var SIGN_SPECS = {
    "rect-18x24": {
      id: "rect-18x24",
      label: "18x24 Rectangle",
      // Default is landscape: the live product photo, the live FIXED_DIMS entry,
      // and GotPrint's own default all agree. The id is not coupled to this.
      shape: "rectangle",
      zones: CORO_CNC_ZONES,
      orientations: {
        portrait: { trimIn: { w: 18, h: 24 } },
        landscape: { trimIn: { w: 24, h: 18 } }
      },
      defaultOrientation: "landscape",
      printedFaces: 2
    },
    "rect-12x18": {
      id: "rect-12x18",
      label: "12x18 Rectangle",
      shape: "rectangle",
      zones: CORO_CNC_ZONES,
      orientations: {
        portrait: { trimIn: { w: 12, h: 18 } },
        landscape: { trimIn: { w: 18, h: 12 } }
      },
      defaultOrientation: "landscape",
      printedFaces: 2
    },
    /**
     * Landscape only — one entry, not a flag. There is no portrait arrow: the
     * silhouette is drawn one way and rotating it 90 degrees is a different
     * design, not a different orientation of this one.
     *
     * Trim is 24w x 18h AS DRAWN. GotPrint labels this file "18 x 24" on a
     * landscape document, which collides with rect-18x24 above. Ours does not.
     *
     * `outline: 'arrow-24x18'` is a key into `outlines/index.ts`, and the geometry
     * behind it now reaches renderers AS DATA: `resolveSign` puts the three `d`
     * strings on `ResolvedSign.outlinePaths`, so neither lane loads a file. The
     * traced source of truth is still
     * `core/sign-core/outlines/sign-outline-arrow-24x18.svg` — three closed paths
     * (`bleed` / `trim` / `safe`) on a viewBox of inches, taken from the shop's CNC
     * die rather than from the old hand-edited art, with the source PDFs out of the
     * repo in `_private/die-sources/`. `outlines/arrow-24x18.ts` transcribes it and
     * `outlines/sign-outline.test.ts` asserts the two are byte-identical.
     *
     * Its trim box measures 23.9982 x 17.9987, not a round 24 x 18. That is the
     * die. The trace shifts the origin so trim starts at 0,0 and changes nothing
     * else — scaling a physical cut path to a rounder number would be inventing
     * geometry, so `outlines/sign-outline.test.ts` asserts 24 x 18 within 0.01"
     * instead of exactly.
     *
     * Bleed is 0.25" here, not 0.125", and the rectangular-document trade is
     * restated at that distance — see `ARROW_CNC_ZONES` above for both.
     */
    "arrow-24x18": {
      id: "arrow-24x18",
      label: "24x18 Arrow",
      shape: "arrow",
      zones: ARROW_CNC_ZONES,
      orientations: {
        landscape: { trimIn: { w: 24, h: 18 }, outline: "arrow-24x18" }
      },
      defaultOrientation: "landscape",
      points: "right",
      pairId: "arrow-24x18",
      printedFaces: 2
    },
    /**
     * The same die, pointing left. A SECOND ROW, not a flag on the row above.
     *
     * WHY A ROW: direction has to reach production, and `Config` — which both
     * lanes already write as a bare spec id — is what carries it. Two rows means
     * `SIGN_SPECS[Config]` resolves for every value either lane can emit, with no
     * suffix parsing anywhere and no tenth line-item property. The full argument,
     * including why this is consistent with keeping ORIENTATION out of the id, is
     * the direction note at the bottom of spec.ts.
     *
     * WHAT IS SHARED AND WHAT IS NOT. Everything geometric is shared: the same
     * `outline` key, so the same traced curves; the same `trimIn`, because a
     * reflection preserves the bounding box; the same `ARROW_CNC_ZONES`, so both
     * arrows resolve to identical zone numbers. `mirror: true` is the entire
     * difference, and it is applied at render by one matrix per lane. There is no
     * second SVG, no reflected copy of the path data, and therefore nothing that
     * can fall out of step with the die.
     *
     * NOT A VARIANT. The Shopify grid stays 9 quantities x 2 sides x 2 stakes = 36.
     * Left and right cut from the same sheet at the same price on the same
     * machine; the only thing that changes is which way the blade runs, which is a
     * production instruction, not a price.
     *
     * THE DIE MIRRORS, THE ARTWORK DOES NOT — see `mirror` on `OrientationOption`.
     */
    "arrow-24x18-l": {
      id: "arrow-24x18-l",
      label: "24x18 Arrow (Left)",
      shape: "arrow",
      zones: ARROW_CNC_ZONES,
      orientations: {
        landscape: { trimIn: { w: 24, h: 18 }, outline: "arrow-24x18", mirror: true }
      },
      defaultOrientation: "landscape",
      points: "left",
      pairId: "arrow-24x18",
      printedFaces: 2
    },
    /**
     * FOLD-OUTS (Session I, 2026-10-25). One continuous printed face on 4mm opaque
     * white coro, white reverse, scored at the centre after printing so it ships
     * folded and opens wide. Installed flat or angled at the crease.
     *
     * Landscape only — one entry, as with the arrow. The fold runs across the
     * 18-inch height; a portrait fold-out would be a different product.
     *
     * ZONES are the rectangles' `CORO_CNC_ZONES`: 0.125" bleed on every OUTER edge
     * (art 36.25 × 18.25 / 48.25 × 18.25) and the house 0.25" safe inset. Nothing
     * at the fold — no internal bleed, no gap, no safe band. The crease is
     * `folds`, a non-printing guide in trim inches (18 / 24 from the left trim
     * edge = 18.125 / 24.125 from the left bleed edge, derived by `resolveSign`).
     *
     * `printedFaces: 1` — single face, always; no Sides axis, so the Shopify grid
     * is 9 quantities × 2 stakes = 18 variants (`signVariantCount`).
     *
     * STAKES: a with-stakes sign gets TWO 15-inch half-step stakes. A note, not a
     * field — no spec row carries a stake count today (see spec.ts).
     *
     * DPI is the flat house press standard (`SIGN_MIN_DPI` 72 / `SIGN_WARN_DPI`
     * 50), same as every other row. For the app lane (I-4): its export cap
     * `MAX_PX = 4096` (lib/printExport.ts:40) gives ~85 DPI across 48.25".
     */
    "foldout-36x18": {
      id: "foldout-36x18",
      label: "36x18 Fold-Out",
      shape: "fold-out",
      zones: CORO_CNC_ZONES,
      orientations: {
        landscape: { trimIn: { w: 36, h: 18 }, folds: [18] }
      },
      defaultOrientation: "landscape",
      printedFaces: 1
    },
    "foldout-48x18": {
      id: "foldout-48x18",
      label: "48x18 Fold-Out",
      shape: "fold-out",
      zones: CORO_CNC_ZONES,
      orientations: {
        landscape: { trimIn: { w: 48, h: 18 }, folds: [24] }
      },
      defaultOrientation: "landscape",
      printedFaces: 1
    }
  };
  var SIGN_SPEC_IDS = Object.keys(SIGN_SPECS);

  // core/sign-core/outlines/arrow-24x18.ts
  var ARROW_24X18_OUTLINE = {
    bleed: "M 18.2367 18.2487 C 17.9053 18.2487 17.5602 18.1816 17.2897 18.0645 C 16.8004 17.8527 16.7274 17.5544 16.7274 17.3954 L 16.7274 16.8671 C 16.7274 16.6506 16.5453 16.4744 16.3215 16.4744 C 16.2987 16.4744 16.2755 16.4763 16.2526 16.48 L 16.2426 16.4816 L 0.8295 17.7205 C 0.7861 17.727 0.742 17.7303 0.6983 17.7303 C 0.4239 17.7303 0.1557 17.5984 -0.0192 17.3775 C -0.1883 17.1639 -0.2511 16.895 -0.1917 16.6393 L 1.4455 9.071 C 1.4588 9.0143 1.4598 8.9698 1.4488 8.9129 L -0.2342 0.9207 C -0.2836 0.6679 -0.2147 0.4049 -0.0452 0.199 C 0.1322 -0.0163 0.3901 -0.1399 0.6624 -0.1399 C 0.7105 -0.1399 0.759 -0.1359 0.8067 -0.128 L 16.2334 1.5378 L 16.2415 1.5392 C 16.2661 1.5435 16.291 1.5457 16.3156 1.5457 C 16.4251 1.5457 16.532 1.5013 16.6088 1.4239 C 16.6818 1.3504 16.7217 1.2539 16.7214 1.1518 L 16.7078 0.6035 C 16.7065 0.4462 16.772 0.2963 16.8972 0.1702 C 17.2049 -0.14 17.7928 -0.25 18.2028 -0.25 C 18.7103 -0.25 19.0723 -0.1007 19.223 0.1705 L 24.1357 8.5486 L 24.1375 8.5519 C 24.2941 8.8387 24.285 9.1619 24.1128 9.4392 L 19.2198 17.8606 L 19.2176 17.8642 C 19.0621 18.1121 18.7137 18.2487 18.2367 18.2487 Z",
    trim: "M 0.7724 0.1197 L 16.1984 1.7855 C 16.6033 1.8563 16.9744 1.5502 16.9714 1.1481 L 16.9578 0.6016 C 16.9531 0.001 18.7164 -0.2358 19.0057 0.2941 L 23.9181 8.6717 C 24.0313 8.8791 24.0243 9.1098 23.8986 9.3101 L 19.0058 17.7313 C 18.6928 18.2303 16.9773 17.9808 16.9773 17.3954 L 16.9773 16.8671 C 16.9773 16.4703 16.6131 16.1683 16.2125 16.2333 L 0.8002 17.472 C 0.3531 17.5447 -0.0496 17.1258 0.0522 16.694 L 1.6888 9.1283 C 1.7103 9.0369 1.7119 8.9556 1.6939 8.8635 L 0.0111 0.8727 C -0.0728 0.443 0.3319 0.0426 0.7724 0.1197 Z",
    safe: "M 18.2366 17.7487 C 17.975 17.7487 17.6953 17.6952 17.4883 17.6056 C 17.2969 17.5227 17.2274 17.4345 17.2274 17.3954 L 17.2274 16.8671 C 17.2274 16.3749 16.821 15.9744 16.3215 15.9744 C 16.2755 15.9744 16.2291 15.9779 16.1832 15.9848 L 0.7701 17.2237 L 0.7602 17.2253 C 0.7397 17.2286 0.7188 17.2303 0.6983 17.2303 C 0.5754 17.2303 0.4537 17.1693 0.3728 17.0671 C 0.3292 17.012 0.2611 16.8977 0.2956 16.7514 L 1.9327 9.1832 C 1.9618 9.0584 1.9639 8.9414 1.9393 8.8155 L 0.2562 0.8232 C 0.2287 0.6795 0.2974 0.5696 0.3408 0.5169 C 0.4216 0.4187 0.5419 0.3601 0.6624 0.3601 C 0.6846 0.3601 0.7071 0.3621 0.7293 0.366 L 0.7374 0.3674 L 16.164 2.0332 C 16.2142 2.0415 16.2651 2.0457 16.3156 2.0457 C 16.5575 2.0457 16.7937 1.9475 16.9637 1.7761 C 17.1317 1.6069 17.2232 1.3832 17.2214 1.1462 L 17.2078 0.5985 C 17.2082 0.5721 17.232 0.5426 17.2521 0.5223 C 17.4062 0.3671 17.8148 0.25 18.2028 0.25 C 18.5271 0.25 18.7418 0.3324 18.7862 0.4139 L 18.7881 0.4173 L 23.7003 8.7946 C 23.7687 8.922 23.764 9.0543 23.6869 9.1773 L 23.6846 9.1809 L 18.7925 17.6009 C 18.7443 17.6725 18.5513 17.7487 18.2366 17.7487 Z",
    /**
     * The vertical axis a mirror reflects about: the trim bbox's centre x, in
     * inches. STATED, not derived — measured off the flattened path at 512 steps
     * per curve, the same way `trimIn` is stated rather than computed. Deriving it
     * would mean flattening beziers inside sign-core, and no path math enters this
     * module (spec.ts, `OutlineRef`).
     *
     * Why the trim ring's centre and not each ring's own: the three rings' centres
     * are 11.99947 (bleed), 11.99910 (trim) and 11.99913 (safe) — within 0.0004"
     * of one another. One axis therefore reflects all three back onto their own
     * bounding boxes to within 0.00074", comfortably inside the 0.01" tolerance
     * the outline tests already use, and the cut line is the ring that has to be
     * right. Reflecting each ring about its own centre would let the three drift
     * apart by a thousandth of an inch for no gain.
     *
     * The nominal 12 is deliberately NOT used: it is 0.0009" off the die's real
     * centre and would leave the mirrored tip at x = 0.0018 instead of 0.0000.
     * Same principle as the un-rounded trim box above.
     */
    mirrorAxisIn: 11.9991
  };

  // core/sign-core/outlines/index.ts
  var SIGN_OUTLINES = {
    "arrow-24x18": ARROW_24X18_OUTLINE
  };

  // core/sign-core/resolve.ts
  function availableOrientations(spec) {
    return Object.keys(spec.orientations);
  }
  function isOrientationAvailable(spec, orientation) {
    return spec.orientations[orientation] !== void 0;
  }
  function pointsSiblings(spec) {
    if (!spec.pairId) return [spec];
    return SIGN_SPEC_IDS.map((id) => SIGN_SPECS[id]).filter(
      (row) => row.pairId === spec.pairId
    );
  }
  function resolveSign(spec, orientation = spec.defaultOrientation) {
    var _a, _b, _c;
    const option = spec.orientations[orientation];
    if (!option) {
      throw new Error(
        `sign-core: spec "${spec.id}" does not offer orientation "${orientation}". Available: ${availableOrientations(spec).join(", ")}.`
      );
    }
    const { w, h } = option.trimIn;
    const { bleedIn, trimToleranceIn, safeMarginIn } = spec.zones;
    const safeInsetIn = trimToleranceIn + safeMarginIn;
    const outline = (_a = option.outline) != null ? _a : null;
    const outlinePaths = outline ? (_b = SIGN_OUTLINES[outline]) != null ? _b : null : null;
    return {
      specId: spec.id,
      label: spec.label,
      shape: spec.shape,
      orientation,
      trimIn: option.trimIn,
      outline,
      outlinePaths,
      // Never true without an outline to reflect: `mirror` is meaningless alone.
      mirror: outlinePaths ? option.mirror === true : false,
      mirrorAxisIn: outlinePaths ? outlinePaths.mirrorAxisIn : null,
      zones: {
        bleed: {
          widthIn: w + bleedIn * 2,
          heightIn: h + bleedIn * 2,
          offsetIn: bleedIn
        },
        cut: {
          widthIn: w,
          heightIn: h,
          offsetIn: 0
        },
        trim: {
          widthIn: Math.max(0, w - trimToleranceIn * 2),
          heightIn: Math.max(0, h - trimToleranceIn * 2),
          offsetIn: -trimToleranceIn
        },
        safe: {
          widthIn: Math.max(0, w - safeInsetIn * 2),
          heightIn: Math.max(0, h - safeInsetIn * 2),
          offsetIn: -safeInsetIn
        }
      },
      printedFaces: spec.printedFaces,
      folds: ((_c = option.folds) != null ? _c : []).map((x) => ({ trimXIn: x, bleedXIn: x + bleedIn }))
    };
  }

  // core/sign-core/dpi.ts
  var SIGN_MIN_DPI = 72;
  var SIGN_WARN_DPI = 50;
  function effectiveDpi(originalPixelWidth, placedWidthIn) {
    if (!Number.isFinite(originalPixelWidth) || originalPixelWidth <= 0) return null;
    if (!Number.isFinite(placedWidthIn) || placedWidthIn <= 0) return null;
    return originalPixelWidth / placedWidthIn;
  }
  function dpiTier(dpi) {
    if (dpi === null || !Number.isFinite(dpi)) return null;
    if (dpi >= SIGN_MIN_DPI) return "ok";
    if (dpi >= SIGN_WARN_DPI) return "warn";
    return "low";
  }

  // core/sign-core/ship-date.ts
  var SHOP_CALENDAR = {
    closedWeekdays: [0, 6],
    cutoffHourCentral: 12
  };
  var PRODUCTION_TIERS = ["standard", "rush", "nextDay"];
  var PRODUCTION_LEAD_BUSINESS_DAYS = {
    standard: { minDays: 3, maxDays: 4 },
    rush: { minDays: 1, maxDays: 2 },
    nextDay: { minDays: 1, maxDays: 1 }
  };
  function calendarDate(year, month, day) {
    const ms = Date.UTC(year, month - 1, day);
    const d = new Date(ms);
    return {
      year: d.getUTCFullYear(),
      month: d.getUTCMonth() + 1,
      day: d.getUTCDate(),
      weekday: d.getUTCDay()
    };
  }
  function toISODate(d) {
    const mm = String(d.month).padStart(2, "0");
    const dd = String(d.day).padStart(2, "0");
    return `${d.year}-${mm}-${dd}`;
  }
  var WEEKDAY_LABELS = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
  var MONTH_LABELS = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec"
  ];
  function formatShipDate(d) {
    return `${WEEKDAY_LABELS[d.weekday]}, ${MONTH_LABELS[d.month - 1]} ${d.day}`;
  }
  function isOpenDay(d, calendar = SHOP_CALENDAR) {
    return !calendar.closedWeekdays.includes(d.weekday);
  }
  function addBusinessDays(from, businessDays, calendar = SHOP_CALENDAR) {
    if (!Number.isInteger(businessDays) || businessDays < 0) {
      throw new RangeError(`addBusinessDays: businessDays must be a non-negative integer, got ${businessDays}`);
    }
    if (calendar.closedWeekdays.length >= 7) {
      throw new RangeError("addBusinessDays: the calendar has no open days");
    }
    let cursor = from;
    let counted = 0;
    while (counted < businessDays) {
      cursor = calendarDate(cursor.year, cursor.month, cursor.day + 1);
      if (isOpenDay(cursor, calendar)) counted++;
    }
    return cursor;
  }
  var HOUR_MS = 36e5;
  var CST_OFFSET_HOURS = -6;
  var CDT_OFFSET_HOURS = -5;
  function nthWeekdayUtc(year, month, weekday, n) {
    const firstDow = new Date(Date.UTC(year, month - 1, 1)).getUTCDay();
    const day = 1 + (weekday - firstDow + 7) % 7 + (n - 1) * 7;
    return Date.UTC(year, month - 1, day);
  }
  function isCentralDaylight(utcMs) {
    const year = new Date(utcMs).getUTCFullYear();
    const start = nthWeekdayUtc(year, 3, 0, 2) + 8 * HOUR_MS;
    const end = nthWeekdayUtc(year, 11, 0, 1) + 7 * HOUR_MS;
    return utcMs >= start && utcMs < end;
  }
  function centralCivil(at) {
    const utcMs = typeof at === "number" ? at : at.getTime();
    if (!Number.isFinite(utcMs)) {
      throw new RangeError("ship-date: order instant is not a valid date");
    }
    const offset = isCentralDaylight(utcMs) ? CDT_OFFSET_HOURS : CST_OFFSET_HOURS;
    const shifted = new Date(utcMs + offset * HOUR_MS);
    return {
      date: calendarDate(shifted.getUTCFullYear(), shifted.getUTCMonth() + 1, shifted.getUTCDate()),
      hour: shifted.getUTCHours()
    };
  }
  function productionStartDate(orderedAt, calendar = SHOP_CALENDAR) {
    const { date, hour } = centralCivil(orderedAt);
    if (isOpenDay(date, calendar) && hour < calendar.cutoffHourCentral) return date;
    return addBusinessDays(date, 1, calendar);
  }
  function shipDate(tier, orderedAt, calendar = SHOP_CALENDAR) {
    const start = productionStartDate(orderedAt, calendar);
    return addBusinessDays(start, PRODUCTION_LEAD_BUSINESS_DAYS[tier].maxDays, calendar);
  }
  function shipDates(orderedAt, calendar = SHOP_CALENDAR) {
    const start = productionStartDate(orderedAt, calendar);
    return {
      standard: addBusinessDays(start, PRODUCTION_LEAD_BUSINESS_DAYS.standard.maxDays, calendar),
      rush: addBusinessDays(start, PRODUCTION_LEAD_BUSINESS_DAYS.rush.maxDays, calendar),
      nextDay: addBusinessDays(start, PRODUCTION_LEAD_BUSINESS_DAYS.nextDay.maxDays, calendar)
    };
  }

  // core/sign-core/rush-price.ts
  var RUSH_LADDER = [
    { minSubtotal: 0, maxSubtotal: 24.99, rush: 5, nextDay: 8 },
    { minSubtotal: 25, maxSubtotal: 99.99, rush: 10, nextDay: 15 },
    { minSubtotal: 100, maxSubtotal: 499.99, rush: 25, nextDay: 40 },
    { minSubtotal: 500, maxSubtotal: 999.99, rush: 50, nextDay: 75 },
    { minSubtotal: 1e3, maxSubtotal: 1999.99, rush: 100, nextDay: 150 },
    { minSubtotal: 2e3, maxSubtotal: 3499.99, rush: 150, nextDay: 225 },
    { minSubtotal: 3500, maxSubtotal: null, rush: 250, nextDay: 375 }
  ];
  function cents(dollars) {
    return Math.round(dollars * 100);
  }
  function bandFor(signSubtotal) {
    if (!Number.isFinite(signSubtotal) || signSubtotal < 0) {
      throw new RangeError(`bandFor: sign subtotal must be a non-negative finite number, got ${signSubtotal}`);
    }
    const subtotalCents = cents(signSubtotal);
    const band = RUSH_LADDER.find(
      (b) => subtotalCents >= cents(b.minSubtotal) && (b.maxSubtotal === null || subtotalCents <= cents(b.maxSubtotal))
    );
    if (!band) {
      throw new RangeError(`bandFor: no band covers $${signSubtotal}`);
    }
    return band;
  }
  function tierFee(tier, signSubtotal) {
    if (tier === "standard") return 0;
    const band = bandFor(signSubtotal);
    return tier === "rush" ? band.rush : band.nextDay;
  }
  function formatFee(fee) {
    if (fee === 0) return "Free";
    return Number.isInteger(fee) ? `$${fee}` : `$${fee.toFixed(2)}`;
  }

  // core/sign-core/sign-selection.ts
  var SIGN_QUANTITIES = [1, 5, 10, 20, 50, 100, 250, 500, 1e3];
  var SIGN_STAKES_OPTIONS = ["with", "without"];
  function sidesFor(spec) {
    return spec.printedFaces === 2 ? ["single", "double"] : ["single"];
  }
  function isSidesAvailable(spec, sides) {
    return sidesFor(spec).includes(sides);
  }
  function expectedVariantKeys(spec) {
    const keys = [];
    for (const quantity of SIGN_QUANTITIES) {
      for (const sides of sidesFor(spec)) {
        for (const stakes of SIGN_STAKES_OPTIONS) keys.push(variantKey(quantity, sides, stakes));
      }
    }
    return keys;
  }
  function signVariantCount(spec) {
    return SIGN_QUANTITIES.length * sidesFor(spec).length * SIGN_STAKES_OPTIONS.length;
  }
  function variantKey(quantity, sides, stakes) {
    return `${quantity}|${sides}|${stakes}`;
  }
  function buildPriceTable(rows) {
    const table = /* @__PURE__ */ new Map();
    for (const row of rows) {
      table.set(variantKey(row.quantity, row.sides, row.stakes), row);
    }
    return table;
  }
  function round2(dollars) {
    return Math.round(dollars * 100) / 100;
  }
  function resolveSelection(selection, priceTable, orderedAt, calendar) {
    const key = variantKey(selection.quantity, selection.sides, selection.stakes);
    const variant = priceTable.get(key);
    if (!variant) {
      throw new Error(
        `resolveSelection: no priced variant for ${key} — the price table holds ${priceTable.size} rows. A truncated variant fetch is the usual cause.`
      );
    }
    const packPrice = variant.packPrice;
    const signSubtotal = round2(packPrice);
    const dates = shipDates(orderedAt, calendar);
    const optionFor = (tier) => {
      const shipDate2 = dates[tier];
      const shipDateLabel = formatShipDate(shipDate2);
      const fee = tierFee(tier, signSubtotal);
      const feeLabel = formatFee(fee);
      return {
        tier,
        shipDate: shipDate2,
        shipDateLabel,
        chipLabel: `Ships ${shipDateLabel} — ${feeLabel}`,
        fee,
        feeLabel,
        total: round2(signSubtotal + fee)
      };
    };
    const tiers = {
      standard: optionFor("standard"),
      rush: optionFor("rush"),
      nextDay: optionFor("nextDay")
    };
    return {
      variant,
      packPrice,
      unitPrice: round2(packPrice / selection.quantity),
      signSubtotal,
      selected: tiers[selection.tier],
      tiers,
      // PRODUCTION_TIERS is slowest-first, which is also checkout's cheapest-first
      // sort (§5g-7). The page and the checkout list the ladder the same way.
      tierOptions: PRODUCTION_TIERS.map((tier) => tiers[tier])
    };
  }

  // core/sign-core/browser.ts
  var SIGN_CORE_VERSION = "6.3";
  return __toCommonJS(browser_exports);
})();
Object.freeze(window.SignCore);

